// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__37YrN","item":"PaymentsMobile_item__1WSMw","label":"PaymentsMobile_label__3PZ_U","amount":"PaymentsMobile_amount__2Ys5F"};